import startCase from 'lodash-es/startCase';

export function pascalCase(str: string = '') {
  return startCase(str.toLowerCase()).replace(/ /g, '');
}
